import { FC } from "react";
import { AdminUsers } from "../../../modules/admin/components/screens/admin-users/admin-users";

export const AdminUsersRoute: FC = () => {
    return (
        <AdminUsers />
    )
}